class AddItemCtrl {

    constructor($scope, $uibModalInstance) {

        this.$scope = $scope;
        this.$uibModalInstance = $uibModalInstance;

        this.$scope.ok = this.ok.bind(this);
        this.$scope.cancel = this.cancel.bind(this);
    }

    ok() {
        this.$uibModalInstance.close(this.$scope.item);
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }

}

angular.module("cpm").controller("AddItemCtrl", ['$scope', '$uibModalInstance', AddItemCtrl]);
